import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import './index.css';
import {getComponentName} from '../../common/utils/namespace';
import {createNamespace} from '../../common/utils';
import {addUnit} from '../../common/utils/format';
import _route from '../../common/utils/route';

var _createNamespace = createNamespace('icon'),
    _createNamespace2 = _slicedToArray(_createNamespace, 1),
    b = _createNamespace2[0];

var TextWrapper = {
    functional: true,
    render: function render(h, config) {
        var $slot = config.slots().default;
        var _config$props = config.props,
            textClass = _config$props.textClass,
            textStyle = _config$props.textStyle;
        return $slot
            ? h(
                  'span',
                  {
                      class: textClass,
                      style: textStyle
                  },
                  [$slot]
              )
            : '';
    }
};
export default {
    name: getComponentName('Icon'),
    data: function data() {
        return {};
    },
    props: {
        name: String,
        size: [Number, String],
        color: String,
        spacing: {
            type: [Number, String],
            default: 8
        },
        info: [Number, String],
        textSize: [Number, String],
        textColor: String,
        textClass: String,
        fontClass: {
            type: String,
            default: 'mai-iconfont'
        },
        classPrefix: {
            type: String,
            default: 'mai-icon'
        },
        url: String,
        replace: Boolean,
        to: [String, Object]
    },
    methods: {
        isImage: function isImage() {
            var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
            return name ? name.indexOf('/') !== -1 : false;
        },
        onClick: function onClick() {
            _route.functionalRoute(this);

            this.$emit('click');
        }
    },
    computed: {
        style: function style() {
            var size = this.size,
                color = this.color;
            var style = {};
            style['fontSize'] = addUnit(size);
            style['color'] = color;
            return style;
        },
        iconClass: function iconClass() {
            var classPrefix = this.classPrefix,
                name = this.name,
                fontClass = this.fontClass;
            var isImg = this.isImage(name);
            var baseClass = b('i');
            var arr = [baseClass];
            fontClass && arr.push(fontClass);
            !isImg && name && arr.push(''.concat(classPrefix, '-').concat(name));
            return arr;
        },
        textStyle: function textStyle() {
            var color = this.color,
                textColor = this.textColor,
                textSize = this.textSize,
                spacing = this.spacing,
                size = this.size;
            var style = {};
            style['fontSize'] = addUnit(textSize) || addUnit(size);
            style['color'] = textColor || color;
            style['marginLeft'] = addUnit(spacing);
            return style;
        },
        textClasses: function textClasses() {
            var textClass = this.textClass;
            var baseClass = b('text');
            var arr = [baseClass];
            textClass && arr.push(textClass);
            return arr;
        }
    },
    render: function render() {
        var h = arguments[0];
        var name = this.name,
            isImage = this.isImage,
            info = this.info,
            style = this.style,
            iconClass = this.iconClass,
            textStyle = this.textStyle,
            textClasses = this.textClasses;
        var isImg = isImage(name);
        return h(
            'div',
            {
                class: b({
                    text: this.$slots.default
                }),
                on: {
                    click: this.onClick
                },
                style: style
            },
            [
                h(
                    'i',
                    {
                        class: iconClass
                    },
                    [
                        isImg
                            ? h('img', {
                                  class: b('image'),
                                  attrs: {
                                      src: name
                                  }
                              })
                            : '',
                        info
                            ? h(
                                  'div',
                                  {
                                      class: b('info')
                                  },
                                  [info]
                              )
                            : ''
                    ]
                ),
                h(
                    TextWrapper,
                    {
                        attrs: {
                            textClass: textClasses,
                            textStyle: textStyle
                        }
                    },
                    [this.$slots.default]
                )
            ]
        );
    },
    install: function install(Vue) {
        Vue.component(this.name, this);
    }
};
